import { render } from "./CoBrandThemeClassicSplit.vue?vue&type=template&id=8f2bbc10&scoped=true"
import script from "./CoBrandThemeClassicSplit.vue?vue&type=script&lang=js"
export * from "./CoBrandThemeClassicSplit.vue?vue&type=script&lang=js"

import "./CoBrandThemeClassicSplit.vue?vue&type=style&index=0&id=8f2bbc10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f2bbc10"]])

export default __exports__